import React, { Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react'
import routesBack from '../../../routesBack'

const BackAppContent = () => {
    return (
        <CContainer className="px-4" lg>
            <Suspense fallback={<CSpinner color="primary" />}>
                <Routes>
                    {routesBack.map((route, idx) =>
                            route.element && (
                                <Route
                                    key={idx}
                                    path={route.path}      // chemins relatifs à /dashboard
                                    element={route.element}
                                />
                            )
                    )}
                    {/* Redirection par défaut vers la racine relative (dashboard) */}
                    <Route path="*" element={<Navigate to="" replace />} />
                </Routes>
            </Suspense>
        </CContainer>
    )
}

export default React.memo(BackAppContent)
